/**
 * @Name: 财务管理 financialManagementStore
 */

import request from '../request'
import apis from '../apis'

export default {

    /** ====================== 预算管理 ============================= */
    /**
     * 获取是否启用预算管理状态
     * @param {*} params
     */
    getIsEnableBudgetManagementSer({ params }) {
        return request.get(apis.IS_ENABLE_BUDGET_MANAGEMENT_STATUS, { params });
    },

    /**
     * 切换是否启用预算管理状态
     * @param {*} params
     */
    changeIsEnableBudgetManagementSer({ params }) {
        return request.get(apis.CHANGE_IS_ENABLE_BUDGET_MANAGEMENT_STATUS, { params });
    },

    /**
     * 获取团组预算详情
     * @param {*} params
     */
    getGroupBudgetDetailSer({ params }) {
        return request.get(apis.GROUP_BUDGET_DETAIL, { params });
    },

    /**
     * 保存预算
     * @param {*} params
     */
    saveBudgetSer({ params }) {
        return request.post(apis.SAVE_BUDGET, params)
    },

    /**
     * 获取预算详情
     * @param {*} params
     */
    getBudgetDetailSer({ params }) {
        return request.get(apis.BUDGET_DETAIL, { params });
    },

    /**
     * 获取预算列表
     * @param {*} pageVO 页码
     * @param {*} params
     */
    getBudgetListSer({ pageVO, params }) {
        return request.get(`${apis.BUDGET_LIST}/${pageVO.pageSize}/${pageVO.curPage}`, { params });
    },

    /**
     * 删除预算
     * @param {*} pageVO 页码
     * @param {*} params
     */
    deleteBudgetSer({ params }) {
        return request.post(apis.DELETE_BUDGET, params)
    },

    /**
     * 导入预算列表数据
     * @param {*} params
     */
    importBudgetListSer({ params, formData }) {
        return request.post(`${apis.IMPORT_ROOM_DATA}?ulType=EventsgoExcelImport&excelType=eventsgo.finance.budgetMgr&modelType=finance&exhiId=${params.exhiId}`, formData)
    },

    /**
     * 导出预算列表数据
     * @param {*} params
     */
    exportBudgetListSer({ params }) {
        return request.get(apis.EXPORT_BUDGET_LIST, { params });
    },

    /**
     * 查询财务报表-库存管理表
     * @param {*} params
     */
    getInventoryListSer({ params }) {
        return request.get(apis.GET_INVENTORY_LIST, { params });
    },

    /**
     * 导出财务报表-库存管理表
     * @param {*} params
     */
    exportInventoryListSer({ params }) {
        return request.get(apis.EXPORT_INVENTORY_LIST, { params });
    }
}
